import { Role } from '@context/shared/types/user';
import { Observable } from 'rxjs';

export type EntityType =
	'folder' | 'file' | 'log' | 'chemical' | 'chemical-log' | 'user';

export const EntityTypeMenuItems: MenuItem<EntityType>[] = [
	{
		key: 'folder',
		icon: '@tui.folder',
	},
	{
		key: 'file',
		icon: '@tui.sprout',
	},
	{
		key: 'log',
		icon: '@tui.notebook-pen',
	},
	{
		key: 'chemical',
		icon: '@tui.flask-conical',
		requiredRole: 'admin',
	},
	{
		key: 'chemical-log',
		icon: '@tui.notebook-pen',
	},
	{
		key: 'user',
		icon: '@tui.user',
		requiredRole: 'admin',
	},
] as const;

export type MenuKey =
	| 'home'
	| 'create'
	| 'notifications'
	| 'archive'
	| 'profile'
	| 'sign-out'
	| 'chemicals'
	| 'users'
	| 'organization'
	| 'switch-organization'
	| 'help';

export type MenuItem<T = MenuKey> = {
	key: T;
	icon: string;

	location?: 'tab' | 'side' | 'all' | 'mobile';

	requiredRole?: Role;

	route?: string;
	handler?: () => void;

	badge$?: Observable<string | null>;
};

export const MenuItems = (opts: {
	createHandler: () => void;
	notificationCount$: Observable<string | null>;
	logoutHandler: () => void;
}): MenuItem[] =>
	[
		{
			key: 'home',
			location: 'all',
			route: 'home',
			icon: '@tui.layout-dashboard',
		},
		{
			key: 'create',
			location: 'tab',
			handler: () => opts.createHandler(),
			icon: '@tui.plus',
		},
		{
			key: 'notifications',
			location: 'all',
			route: 'notifications',
			icon: '@tui.bell',
			badge$: opts.notificationCount$,
		},
		{
			key: 'archive',
			location: 'side',
			route: 'archive',
			icon: '@tui.archive',
		},
		{
			key: 'chemicals',
			location: 'side',
			route: 'chemicals',
			icon: '@tui.flask-conical',
		},
		{
			key: 'users',
			location: 'side',
			route: 'users',
			icon: '@tui.users',
			requiredRole: 'admin',
		},
		{
			key: 'organization',
			location: 'side',
			route: 'organization',
			icon: '@tui.building',
			requiredRole: 'owner',
		},
		{
			key: 'profile',
			location: 'side',
			route: 'profile',
			icon: '@tui.circle-user',
		},
	] as const;
